/**
 * Created by Bart Decorte
 * Date: 06/07/2020
 * Time: 10:51
 */

export default class Toast {
  constructor(body = '', header = 'Unleash CMS') {
    this.header = header;
    this.body = body;
    this.timing = '';
    this.ariaLive = 'polite';
    this.container = document.querySelector('.toasts');
  }

  show() {
    const element = this.append();
    const toast = $(element).toast({
      delay: 7000,
    });
    toast.toast('show');
  }

  append() {
    let element = document.createElement('div');
    element.innerHTML = this.markup().trim();
    element = element.firstChild;
    this.container.append(element);
    return element;
  }

  iconMarkup() {
    return '';
  }

  markup() {
    const {
      header,
      body,
      timing,
      ariaLive,
    } = this;

    const iconMarkup = this.iconMarkup();

    return `
      <div class="toast" role="alert" aria-live="${ariaLive}" aria-atomic="true" style="opacity: 1;">
        <div class="toast-header">

          <!-- Heading -->
          <h4 class="mb-0 mr-auto">
            ${iconMarkup}
            ${header}
          </h4>

          <!-- Text -->
          <small class="text-muted">${timing}</small>

          <!-- Button -->
          <button type="button" class="ml-3 mb-n1 close" data-dismiss="toast" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>

        </div>
        <div class="toast-body text-sm">
          ${body}
        </div>
      </div>
    `;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/toasts/Toast.js